import type { PrimitiveData } from './logger';
import { getLogger } from './logger';

const { logTrack } = getLogger({ name: 'idv2', location: 'analytics' });

const trackEvent = (name: string, properties?: PrimitiveData) => {
  logTrack(`${name}`, properties ?? {});
};

export const trackPageView = (pageName: string, properties?: PrimitiveData) => {
  trackEvent('page_view', { page: pageName, ...properties });
};

export const trackClick = (elementName: string, properties?: PrimitiveData) => {
  trackEvent('click', { element: elementName, ...properties });
};

export const trackTimeSpent = (pageName: string, properties?: PrimitiveData) => {
  trackEvent('time_spent', { page: pageName, ...properties });
};
